import React, { useState } from "react";

import RiskTagsDropdown from "./risk_tags_dropdown";
import { RisksComparison } from "../../risks_comparison";
import RiskComparisonModal from "../../../components/risk_comparison_modal";

import { getText } from "../../../helpers";

import './index.css';

export default function UnwantedEventCellFormatter(props) {
  const { cell, row, permission, isRisksComparisonEnabled, isUnwantedEventsComparisonEnabled, TagOptions, refreshUpdatedRisk, riskRatingDict, likelihoodConversionToView } = props;
  const [ risksComparisonShown, setRisksComparisonShown ] = useState(false);
  const [ riskComparisonModalShown, setRiskComparisonModalShown ] = useState(false);

  const isCustom = ["work_phase", "activity", "hazard", "unwanted_event"].includes(row.is_custom);
  const cellClassname = isCustom ? "cell-style unwanted-event-cell editable-cell" : "cell-style unwanted-event-cell";

  const showRisksComparison = () => {
    setRisksComparisonShown(true)
  }

  const hideRisksComparison = () => {
    setRisksComparisonShown(false)
    window.location.reload();
  }

  return (
    <span className={cellClassname}>
      <div>{ cell }</div>
      <RiskTagsDropdown
        riskRow={row}
        disabled={!permission.can_update}
      />
      {
        isRisksComparisonEnabled && permission && permission.can_update &&
        <div className="link text-light-blue" onClick={showRisksComparison}>
          {getText("Compare Controls")}
        </div>
       }
      {
        isUnwantedEventsComparisonEnabled && permission.can_read && (
          <div
            onClick={() => setRiskComparisonModalShown(true)}
            className="link text-light-blue compare-unwanted-events-button-link"
          >
            {getText("Compare Unwanted Events")}
          </div>
        )
      }
      {
        risksComparisonShown &&
        <RisksComparison
          hideRisksComparison={hideRisksComparison}
          risk={row}
        />
      }
      {
        riskComparisonModalShown &&
        <RiskComparisonModal
          risk={row}
          hideModal={() => setRiskComparisonModalShown(false)}
          TagOptions={TagOptions}
          refreshUpdatedRisk={refreshUpdatedRisk}
          riskRatingDict={riskRatingDict}
          likelihoodConversionToView={likelihoodConversionToView}
        />
      }
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/views/plan_tables/formatters/unwanted_event_cell_formatter.js